import { Button, Space, Tooltip } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { useTranslation } from 'react-i18next';
import IconWrapper from '../../../../shared/components/icon-wrapper/icon-wrapper';
import Table from '../../../../shared/components/table/table';
import { PencilSquareIcon } from '../../../../shared/icons/pencil-square-icon';
import { TrashIcon } from '../../../../shared/icons/trash-icon';
import { useAppDispatch } from '../../../../store/hooks';
import styles from '../../../../styles/components/scan-sign-requests-table.module.css';
import { openModal } from '../../../ui/store/ui-slice';
import { clientGroupFormDeleteModalId, clientGroupFormModalId } from '../../constants/constants';
import { ClientGroup } from '../../models/client-group';
import { setActiveClientGroupId } from '../../store/client-groups-slice';

interface Props {
  isFetchingClientGroups: boolean;
  clientGroupsDataSource: ClientGroup[];
}

const ClientGroupsTable = ({ isFetchingClientGroups, clientGroupsDataSource }: Props): JSX.Element => {
  const { t } = useTranslation('common');
  const dispatch = useAppDispatch();

  const openClientGroupModal = (modalId: string, activeClientGroupId: string) => {
    dispatch(openModal(modalId));
    dispatch(setActiveClientGroupId(activeClientGroupId));
  };

  const columns: ColumnsType<(typeof clientGroupsDataSource)[number]> = [
    {
      title: t('label.name'),
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: t('label.customers'),
      dataIndex: 'customers',
      key: 'customers',
    },
    {
      title: t('label.users'),
      dataIndex: 'users',
      key: 'users',
    },
    {
      title: t('label.templates'),
      dataIndex: 'templates',
      key: 'templates',
    },
    {
      title: t('label.actions'),
      key: 'actions',
      fixed: 'right',
      width: 124,
      render: (_, { system, id }) => (
        <Space size="middle">
          {!system && (
            <>
              <Tooltip mouseEnterDelay={0.5} title={t('action.edit')}>
                <Button
                  onClick={() => openClientGroupModal(clientGroupFormModalId, id)}
                  type="text"
                  shape="circle"
                  icon={
                    <IconWrapper>
                      <PencilSquareIcon />
                    </IconWrapper>
                  }
                />
              </Tooltip>
              <Tooltip mouseEnterDelay={0.5} title={t('action.delete')}>
                <Button
                  onClick={() => openClientGroupModal(clientGroupFormDeleteModalId, id)}
                  type="text"
                  shape="circle"
                  icon={
                    <IconWrapper
                      textProps={{
                        type: 'warning',
                      }}
                    >
                      <TrashIcon />
                    </IconWrapper>
                  }
                />
              </Tooltip>
            </>
          )}
        </Space>
      ),
    },
  ];

  return (
    <div className={styles.tableContainer}>
      <Table
        tableProps={{
          rowKey: ({ id }: ClientGroup) => id,
          scroll: {
            y: '100%',
          },
          loading: isFetchingClientGroups,
          dataSource: clientGroupsDataSource,
          columns,
        }}
      />
    </div>
  );
};

export default ClientGroupsTable;
